var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBeerAndCider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Beer-Mug--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Beer Mug Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 12.77a3 3 0 0 0 -3 -3h-0.75A0.25 0.25 0 0 0 19 10v1.5a0.25 0.25 0 0 0 0.25 0.25H20a1 1 0 0 1 1 1v3.5a1 1 0 0 1 -0.86 1h-0.89a0.25 0.25 0 0 0 -0.25 0.25v0.94a0.19 0.19 0 0 0 0 0.08c0.06 0.18 0.13 0.37 0.19 0.56a0.26 0.26 0 0 0 0.24 0.17h0.69a2.94 2.94 0 0 0 2.86 -3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.6A3.69 3.69 0 0 0 17 3a0.25 0.25 0 0 1 -0.16 -0.11 6 6 0 0 0 -5 -2.65 5.87 5.87 0 0 0 -4.71 2.33 0.25 0.25 0 0 1 -0.27 0.09 4.32 4.32 0 0 0 -1.28 -0.19 4.58 4.58 0 0 0 -1.26 9 0.25 0.25 0 0 1 0.18 0.24v7a0.47 0.47 0 0 1 0 0.17 17.77 17.77 0 0 0 -1 3.42A1.5 1.5 0 0 0 5 23.77h12a1.5 1.5 0 0 0 1.5 -1.5 17.77 17.77 0 0 0 -1 -3.42 0.47 0.47 0 0 1 0 -0.17v-8.42a0.25 0.25 0 0 1 0.16 -0.24A3.65 3.65 0 0 0 20 6.6ZM5.58 4.47a2.64 2.64 0 0 1 1.33 0.37 1 1 0 0 0 0.8 0.11 1 1 0 0 0 0.62 -0.52 3.88 3.88 0 0 1 3.51 -2.2 4 4 0 0 1 3.58 2.13 1 1 0 0 0 0.9 0.55A1.69 1.69 0 0 1 18 6.6a1.7 1.7 0 0 1 -1.68 1.68h-4.48a1.9 1.9 0 0 0 -1.84 1.9v0.45a1.69 1.69 0 0 1 -3.37 0 1 1 0 0 0 -1 -1 2.58 2.58 0 0 1 0 -5.16ZM9.5 19.52a0.75 0.75 0 0 1 -1.5 0v-4.25a0.75 0.75 0 0 1 1.5 0Zm4.5 0a0.75 0.75 0 0 1 -1.5 0v-6.75a0.75 0.75 0 0 1 1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBeerAndCider);
export default ForwardRef;